module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image21.67c53730.jpg";